import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

import ConditionalWrapper from '@/components/ui/custom/ConditionalWrapper';
import { Tooltip } from '@/components/ui/daisy';
import { TooltipPlacement } from '@/components/ui/daisy/tooltip/types';
import { usePedWorkspaceStatus } from '@/data/context/PedWorkspaceContext';

type PedWorkspaceGuardProps = {
  children: ReactNode;
  className?: string;
  placement?: TooltipPlacement;
  isBlocked?: boolean;
};

export default function PedWorkspaceGuard({
  children,
  className,
  placement,
  isBlocked,
}: PedWorkspaceGuardProps) {
  const { t } = useTranslation('translation', {
    keyPrefix: 'adminPage.editCourseRules',
  });
  const { isLimitedEdition, isPublished } = usePedWorkspaceStatus();

  return (
    <ConditionalWrapper
      condition={isBlocked ?? isLimitedEdition}
      wrapper={
        <Tooltip
          text={t(isPublished ? 'cantModifyPublished' : 'cantModify')}
          placement={placement}
          className={className}
        />
      }
    >
      {children}
    </ConditionalWrapper>
  );
}
